var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Offer, SERVICE_TYPE_DEVICE_INSURANCE } from '../../schema';
import { EShopService } from '../eshop';
import { Configurator } from '@api/services/configurator';
import { getOptions } from '@api/utils';
var OffersService = /*@__PURE__*/ (function () {
    function OffersService() {
    }
    OffersService.findAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.offers];
                }
            });
        });
    };
    OffersService.findAllDiscounts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.discounts];
                }
            });
        });
    };
    OffersService.findOneDiscountById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var discounts;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, OffersService.findAllDiscounts()];
                    case 1:
                        discounts = _a.sent();
                        if (!discounts[id]) {
                            throw new Error("Discount id " + id + " doesn't exist.");
                        }
                        return [2 /*return*/, discounts[id]];
                }
            });
        });
    };
    OffersService.findAllServices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.services];
                }
            });
        });
    };
    OffersService.findOneServiceById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var services;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, OffersService.findAllServices()];
                    case 1:
                        services = _a.sent();
                        if (!services[id]) {
                            throw new Error("Service id " + id + " doesn't exist.");
                        }
                        return [2 /*return*/, services[id]];
                }
            });
        });
    };
    OffersService.findOneByComponentSet = function (set) {
        return __awaiter(this, void 0, void 0, function () {
            var offers, ids, _i, set_1, component, id, type, key, _a, set_2, component, _b, set_3, component, id, type, data, offer;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, OffersService.findAll()];
                    case 1:
                        offers = _c.sent();
                        ids = [];
                        for (_i = 0, set_1 = set; _i < set_1.length; _i++) {
                            component = set_1[_i];
                            if (!component) {
                                continue;
                            }
                            if (component.type === 'hardwareMobile') {
                                if (component.hasEquivalentBundle()) {
                                    component.stopEventListeners();
                                    component.switchToEquivalentBundle();
                                    component.resumeEventListeners();
                                }
                                else if (component.hasTopSmartphoneDeal() && !component.topSmartphoneDealDisabled) {
                                    component.stopEventListeners();
                                    component.useTopSmartphoneDeal();
                                    component.resumeEventListeners();
                                }
                            }
                            id = component.getCurrentVersion().id;
                            type = component.type;
                            ids.push(type + id);
                        }
                        key = ids.sort().join('_');
                        if (!offers[key]) {
                            for (_a = 0, set_2 = set; _a < set_2.length; _a++) {
                                component = set_2[_a];
                                if (!component) {
                                    continue;
                                }
                                if (component.type === 'hardwareMobile') {
                                    if (component.currentVersionContainsBundle()) {
                                        component.stopEventListeners();
                                        component.switchToEquivalentWithoutBundle();
                                        component.resumeEventListeners();
                                    }
                                    else if (component.hasTopSmartphoneDeal()) {
                                        component.stopEventListeners();
                                        component.unuseTopSmartphoneDeal();
                                        component.resumeEventListeners();
                                    }
                                    else {
                                        throw new Error('Could not find an offer.');
                                    }
                                }
                            }
                            ids = [];
                            for (_b = 0, set_3 = set; _b < set_3.length; _b++) {
                                component = set_3[_b];
                                if (!component) {
                                    continue;
                                }
                                id = component.getCurrentVersion().id;
                                type = component.type;
                                ids.push(type + id);
                            }
                            key = ids.sort().join('_');
                            if (!offers[key]) {
                                throw new Error('Could not find an offer.');
                            }
                        }
                        data = offers[key];
                        offer = new Offer;
                        offer.loadJSON(data);
                        return [2 /*return*/, offer];
                }
            });
        });
    };
    OffersService.cancelOptions = function (option) {
        return __awaiter(this, void 0, void 0, function () {
            var offers, key, offer, options, match, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, OffersService.findAll()];
                    case 1:
                        offers = _a.sent();
                        for (key in offers) {
                            offer = offers[key];
                            options = offer.usedOptions;
                            match = -1;
                            for (i = 0; i < options.length; i++) {
                                if (options[i].id === option.id) {
                                    match = i;
                                    break;
                                }
                            }
                            if (match > -1) {
                                if (!offer.removedOptions) {
                                    offer.removedOptions = [];
                                }
                                offer.removedOptions.push(option);
                                if (SERVICE_TYPE_DEVICE_INSURANCE === option.description.additional.type) {
                                    offer.insuranceOption = [];
                                }
                                offer.usedOptions.splice(match, 1);
                            }
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    OffersService.useOptions = function (option) {
        return __awaiter(this, void 0, void 0, function () {
            var offers, key, offer, options, _i, options_1, usedOption, availableOptions, _a, availableOptions_1, availableOption, removedOptions, match, i;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, OffersService.findAll()];
                    case 1:
                        offers = _b.sent();
                        for (key in offers) {
                            offer = offers[key];
                            if (offer.id === Configurator.getOffer().offerId) {
                                continue;
                            }
                            if (!offer.removedOptions) {
                                offer.removedOptions = [];
                            }
                            if (!offer.insuranceOption) {
                                offer.insuranceOption = [];
                            }
                            if (!offer.usedOptions) {
                                offer.usedOptions = [];
                            }
                            options = offer.usedOptions;
                            for (_i = 0, options_1 = options; _i < options_1.length; _i++) {
                                usedOption = options_1[_i];
                                if (usedOption.id === option.id) {
                                    continue;
                                }
                            }
                            availableOptions = getOptions(offer);
                            for (_a = 0, availableOptions_1 = availableOptions; _a < availableOptions_1.length; _a++) {
                                availableOption = availableOptions_1[_a];
                                if (availableOption.id === option.id) {
                                    offer.usedOptions.push(availableOption);
                                    if (SERVICE_TYPE_DEVICE_INSURANCE === option.description.additional.type) {
                                        offer.insuranceOption.push(option);
                                    }
                                    removedOptions = offer.removedOptions;
                                    match = -1;
                                    for (i = 0; i < removedOptions.length; i++) {
                                        if (removedOptions[i].id === option.id) {
                                            match = i;
                                            break;
                                        }
                                    }
                                    if (match > -1) {
                                        offer.removedOptions.splice(match, 1);
                                    }
                                }
                            }
                        }
                        return [2 /*return*/, true];
                }
            });
        });
    };
    return OffersService;
}());
export { OffersService };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/offers/offers.ts
// module id = null
// module chunks = 